var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.819,
    height: 31.82,
    viewBox: "0 0 31.819 31.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1631",
    "data-name": "Grupo 1631",
    transform: "translate(-2202.638 -7869.391) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_615",
    "data-name": "Ret\\xE2ngulo 615",
    width: 9,
    height: 34,
    transform: "translate(7140 3989)",
    fill: "#d3ff9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_1",
    "data-name": "Pol\\xEDgono 1",
    d: "M4.5,0,9,2H0Z",
    transform: "translate(7149 4025) rotate(180)",
    fill: "#d3ff9a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.2631a4b680ff8a7882b31cc1ff1d787c.svg";
export { ForwardRef as ReactComponent };